import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from '@adsk/alloy-react-box';
import Theme from '@adsk/alloy-react-theme';
const TrialModalCarousel = _ref => {
  let {
    children
  } = _ref;
  const [active, setActive] = useState(0);
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    border: "1px solid ".concat(Theme.colors.charcoal200),
    borderRadius: "4px",
    flexDirection: "column",
    width: "100%"
  }, children[active], /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-evenly",
    width: "".concat(children.length * 3, "%")
  }, children.map((_, index) => {
    return /*#__PURE__*/React.createElement(Box, {
      backgroundColor: active === index ? Theme.colors.charcoal600 : Theme.colors.charcoal200,
      borderRadius: "50%",
      display: "inline",
      height: "8px",
      left: "50%",
      margin: "-4px 0",
      position: "relative",
      top: "-15px",
      width: "8px",
      style: {
        cursor: 'pointer'
      },
      "data-testid": "TrialModalCarouselDot".concat(index),
      key: "carousel-dot-".concat(index),
      onClick: () => {
        setActive(index);
      }
    });
  })));
};
TrialModalCarousel.displayName = 'TrialModalCarousel';
TrialModalCarousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};
export default TrialModalCarousel;
//# sourceMappingURL=component.js.map